import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import * as Sentry from "@sentry/vue";
import { useAuthenticationStore } from "@/stores/authenticationStore";

export const useAuthenticationHandshake = () => {
    const route = useRoute();
    const router = useRouter();

    const accessToken = computed(() => route.query.token);

    const authentication = useAuthenticationStore();

    const initializeToken = async () => {
        try {
            await router.isReady();

            if (accessToken.value) {
                authentication.saveAccessToken(accessToken.value as string);

                return;
            }

            if (!authentication.accessToken) redirectToLoginPage();
        } catch (err) {
            Sentry.captureException(err);

            return;
        }
    };

    const redirectToLoginPage = () => {
        window.open(import.meta.env.VITE_UNIFIED_LOGIN_URL, "_self");
    };


    return {
        initializeToken,
    };
};
